import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticatedState, setIsAuthenticatedState] = useState(false);

  useEffect(() => {
    // Check authentication state after component mounts
    const checkAuth = () => {
      const adminUser = localStorage.getItem('adminUser');
      const adminCredentials = localStorage.getItem('adminCredentials');
      setIsAuthenticatedState(!!(adminUser && adminCredentials));
      setIsLoading(false);
    };

    // Small delay to ensure localStorage is loaded
    const timer = setTimeout(checkAuth, 100);
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        background: '#0f1923'
      }}>
        <div style={{ color: '#8899a6', fontSize: '14px' }}>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticatedState) {
    return <Navigate to="/console/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
